import { Dispatch, useEffect } from 'react'

import { getLoadedInitialList } from 'conversations/modules/message/selectors'
import { abilityEnabledFromAnyTeam } from 'conversations/modules/teams/selectors'
import { useDispatch, useSelector } from 'react-redux'
import { fetchMessagesAsync } from 'shared/store/actions/message'

import { RootAction } from 'typesafe-actions'

export const useFetchConversationMessages = (conversationId: number, shouldFetch: boolean) => {
  const dispatch = useDispatch<Dispatch<RootAction>>()
  const alreadyFetched = useSelector(getLoadedInitialList(conversationId))
  const responseTimerEnabled = useSelector(abilityEnabledFromAnyTeam('responseTimerEnabled'))
  const doFetch = responseTimerEnabled && shouldFetch && !alreadyFetched

  useEffect(() => {
    doFetch &&
      dispatch(
        fetchMessagesAsync.request({
          conversationId,
          loadMore: false,
          limit: 50,
        })
      )
  }, [doFetch, dispatch, conversationId])
}
